import { useState } from "react";

// The MUI theme/ThemeProvider was removed in the Arco migration — Arco handles
// component theming via its ConfigProvider + CSS vars. This hook is kept only so
// the Settings "Colors" picker still has a bit of state to drive; `primary` is a
// plain hex string now (was a MUI color object).
export function useTheme() {
  return useState({ primary: "#165DFF" });
}
